/* Huta · barra de progreso "envío gratis".
 *
 * Mantiene al día TODAS las instancias de la barra que haya en la página
 * (cajón de Qikify, ficha de producto y /cart) con un único estado.
 *
 * El estado inicial lo pinta Liquid; a partir de ahí el importe se lee siempre
 * de /cart.js, nunca del DOM de la app del cajón.
 */
(function () {
  'use strict';

  var CFG = window.__HUTA_SHIP_BAR__;
  if (!CFG || !window.fetch) return;

  /* ------------------------------------------------------------------ *
   * Selectores del cajón de la app "Qikify Slide Cart" (código ajeno).
   * Es lo único que hay que cambiar si la app actualiza su markup.
   * Estructura observada:
   *   .qsc2-drawer__content > .qsc2-drawer-wrapper
   *     > .qsc2-drawer-header      (título "Tu carrito" + cerrar)
   *     > [.qsc2-drawer-announcement]
   *     > .qsc2-drawer-body        (lista de productos)
   *     > .qsc2-drawer-footer
   * ------------------------------------------------------------------ */
  var QK_WRAPPER = '.qsc2-drawer-wrapper';
  var QK_HEADER = '.qsc2-drawer-header';
  var QK_ANNOUNCEMENT = '.qsc2-drawer-announcement';
  var QK_BODY = '.qsc2-drawer-body';

  /* Parámetro propio de Qikify: marca una petición al carrito como "no
   * reacciones a esto". Lo usamos al añadir desde /cart, para que la app no abra
   * su cajón encima de la página. En el cajón NO se usa: ahí sí queremos que la
   * app refresque su lista. Si algún día deja de existir, lo peor que pasa es
   * que el cajón se abra un instante antes de recargar. */
  var QK_SILENT = 'sc-silently-change-cart=true';

  var THRESHOLD = parseInt(CFG.threshold, 10) || 0;
  var ROUTE_CART = (CFG.routes && CFG.routes.cart) || '/cart.js';
  var ROUTE_ADD = (CFG.routes && CFG.routes.add) || '/cart/add.js';
  var TEMPLATE_ID = 'huta-ship-bar-drawer-template';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var nativeFetch = window.fetch.bind(window);

  var state = {
    total: parseInt(CFG.initialTotal, 10) || 0,
    ids: (CFG.cartProductIds || []).map(Number),
  };

  /* ------------------------------------------------------------------ *
   * Pintado
   * ------------------------------------------------------------------ */

  /* Mismo formato que snippets/huta-money-es.liquid: coma decimal, símbolo
   * detrás y espacio duro. Sin Intl a propósito, para que el importe pintado en
   * Liquid y el actualizado por JS sean idénticos. */
  function money(cents) {
    var value = Math.max(0, Math.round(cents || 0));
    var dec = value % 100;
    return Math.floor(value / 100) + ',' + (dec < 10 ? '0' : '') + dec + '\u00a0€';
  }

  /* Escribir texto idéntico también cuenta como mutación del DOM, y el
   * observador del cajón nos devolvería la llamada: solo se escribe si cambia. */
  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function fillMessage(template, missing) {
    return String(template || '').replace(/\{\{\s*amount\s*\}\}/g, money(missing));
  }

  /* El más barato que llegue a cubrir el hueco: así al añadirlo el envío gratis
   * queda realmente conseguido. Si ninguno llega, no se propone nada. */
  function pickSuggestion(missing) {
    if (!CFG.suggest) return null;

    var list = CFG.candidates || [];
    var best = null;

    for (var i = 0; i < list.length; i++) {
      var candidate = list[i];
      if (!candidate || !candidate.vid) continue;
      if (candidate.price < missing) continue;
      if (state.ids.indexOf(Number(candidate.id)) !== -1) continue;
      if (!best || candidate.price < best.price) best = candidate;
    }

    return best;
  }

  function renderSuggestion(bar, suggestion) {
    var box = bar.querySelector('[data-ship-suggest]');
    if (!box) return;

    if (!suggestion) {
      box.hidden = true;
      return;
    }

    var img = box.querySelector('[data-ship-suggest-img]');
    if (img) {
      if (suggestion.img) {
        if (img.getAttribute('src') !== suggestion.img) img.setAttribute('src', suggestion.img);
        if (img.getAttribute('alt') !== suggestion.title) img.setAttribute('alt', suggestion.title || '');
        img.hidden = false;
      } else {
        img.removeAttribute('src');
        img.hidden = true;
      }
    }

    setText(box.querySelector('[data-ship-suggest-name]'), suggestion.title || '');
    setText(box.querySelector('[data-ship-suggest-price]'), money(suggestion.price));

    var button = box.querySelector('[data-ship-suggest-add]');
    if (button) {
      button.setAttribute('data-variant-id', String(suggestion.vid));
      button.disabled = false;
    }

    box.hidden = false;
  }

  function render() {
    var bars = document.querySelectorAll('[data-huta-ship-bar]');
    if (!bars.length) return;

    var total = Math.max(0, state.total);
    var missing = Math.max(0, THRESHOLD - total);
    var pct = THRESHOLD > 0 ? Math.min(100, (total * 100) / THRESHOLD) : 0;
    var done = THRESHOLD > 0 && missing === 0;
    var key = total <= 0 ? 'empty' : done ? 'done' : 'progress';

    var message = fillMessage(CFG.messages && CFG.messages[key], missing);
    var suggestion = key === 'progress' ? pickSuggestion(missing) : null;

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      bar.classList.toggle('is-done', done);

      setText(bar.querySelector('[data-ship-msg]'), message);
      setText(bar.querySelector('[data-ship-current]'), money(total));
      setText(bar.querySelector('[data-ship-goal]'), money(THRESHOLD));

      var track = bar.querySelector('[data-ship-track]');
      if (track) {
        track.setAttribute('aria-valuemax', String(THRESHOLD));
        track.setAttribute('aria-valuenow', String(Math.min(total, THRESHOLD)));
        track.setAttribute('aria-label', message);
      }

      var fill = bar.querySelector('[data-ship-fill]');
      if (fill) fill.style.width = Math.round(pct * 100) / 100 + '%';

      renderSuggestion(bar, suggestion);
    }
  }

  /* ------------------------------------------------------------------ *
   * Dato: siempre de /cart.js
   * ------------------------------------------------------------------ */
  var refreshTimer = null;
  var inFlight = false;

  function refreshNow() {
    if (inFlight) return;
    inFlight = true;

    nativeFetch(ROUTE_CART, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart && typeof cart.total_price === 'number') {
          state.total = cart.total_price;
          state.ids = (cart.items || []).map(function (item) {
            return Number(item.product_id);
          });
          render();
        }
      })
      .catch(function () {
        /* Si el carrito no responde, se deja lo último que se sabía. */
      })
      .then(function () {
        inFlight = false;
      });
  }

  /* Una sola recalculación por interacción, aunque lleguen varios avisos. */
  function refresh(delay) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshNow, typeof delay === 'number' ? delay : 150);
  }

  /* ------------------------------------------------------------------ *
   * Cajón de Qikify: reinsertar y recalcular
   * ------------------------------------------------------------------ */
  var template = null;

  /* La cabecera y la lista pueden venir envueltas en su propio componente: se
   * sube hasta el hijo directo del cajón para colocar la banda entre bloques
   * enteros y no dentro de uno. */
  function directChild(parent, node) {
    while (node && node.parentNode && node.parentNode !== parent) node = node.parentNode;
    return node && node.parentNode === parent ? node : null;
  }

  function drawerBar() {
    var wrapper = document.querySelector(QK_WRAPPER);
    /* La app no está en la página: no hay nada que hacer, y sin ruido en
     * consola. */
    if (!wrapper) return null;

    var existing = wrapper.querySelector('.huta-ship-bar--drawer');
    if (existing) return existing;

    if (!template) {
      template = document.getElementById(TEMPLATE_ID);
      if (!template || !template.content) return null;
    }

    var source = template.content.firstElementChild;
    if (!source) return null;

    /* Debajo de la cabecera (y del aviso, si la app lo muestra) y encima de la
     * lista de productos. */
    var body = wrapper.querySelector(QK_BODY);
    var after =
      directChild(wrapper, wrapper.querySelector(QK_ANNOUNCEMENT)) ||
      directChild(wrapper, wrapper.querySelector(QK_HEADER));

    /* Si cabecera y lista comparten contenedor, colocarse "después de la
     * cabecera" dejaría la banda debajo de los productos: mejor ir por la lista. */
    if (after && body && after.contains(body)) after = null;

    if (after) return wrapper.insertBefore(source.cloneNode(true), after.nextSibling);

    var before = directChild(wrapper, body);
    if (before) return wrapper.insertBefore(source.cloneNode(true), before);

    return null;
  }

  /* Qikify (Vue) redibuja su cajón en cada cambio de cantidad, así que la barra
   * hay que reinsertarla. Es idempotente: si ya está puesta, no se toca. */
  var syncScheduled = false;

  function syncDrawer() {
    if (!CFG.drawer || syncScheduled) return;
    syncScheduled = true;

    requestAnimationFrame(function () {
      syncScheduled = false;
      if (drawerBar()) render();
    });
  }

  if (CFG.drawer && window.MutationObserver) {
    new MutationObserver(syncDrawer).observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------ *
   * Disparadores
   * ------------------------------------------------------------------ */

  /* Red de seguridad: cualquier escritura en el carrito, venga del tema, de la
   * app o de nuestra propia sugerencia, recalcula la barra. */
  window.fetch = function () {
    var request = arguments[0];
    var url = typeof request === 'string' ? request : request && request.url;

    return nativeFetch.apply(window, arguments).then(function (response) {
      if (url && response && response.ok && CART_WRITE.test(String(url))) refresh();
      return response;
    });
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (url && CART_WRITE.test(String(url))) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) refresh();
      });
    }
    return nativeOpen.apply(this, arguments);
  };

  [
    'cart:update',
    'cart:add',
    'stickycart-event-sc-loaded',
    'stickycart-event-sc-show',
    'stickycart-event-drawer-update-quantity',
  ].forEach(function (name) {
    document.addEventListener(name, function () {
      syncDrawer();
      refresh();
    });
  });

  /* ------------------------------------------------------------------ *
   * Botón "Añadir" de la sugerencia
   * ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-ship-suggest-add]') : null;
    if (!button || button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    event.preventDefault();
    button.disabled = true;

    var bar = button.closest('[data-huta-ship-bar]');
    var onCartPage = !!bar && bar.getAttribute('data-variant') === 'cart';
    var url = onCartPage ? ROUTE_ADD + (ROUTE_ADD.indexOf('?') === -1 ? '?' : '&') + QK_SILENT : ROUTE_ADD;

    nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        if (onCartPage) {
          /* En /cart hay que recargar para que el artículo nuevo aparezca en el
           * resumen del pedido. En el cajón no: la app refresca su lista sola. */
          window.location.reload();
          return;
        }
        refresh(0);
      })
      .catch(function () {
        /* Si falla, el carrito se queda como estaba y el botón vuelve a estar
         * disponible. */
        button.disabled = false;
      });
  });

  /* ------------------------------------------------------------------ *
   * Arranque
   * ------------------------------------------------------------------ */
  syncDrawer();
  render();
})();
